import { FSAccessorySubName, mapFSAccessorySubNames } from "./AccessorySubName";

/* **************************************************** Finishing Shedule Accessory Name */
export interface FSAccessoryName {
    id: number;
    accessory_name: string;
    created_by: number | null;
    sub_accessory?: FSAccessorySubName[];
}

export const mapFSAccessoryName = (data: any): FSAccessoryName => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSAccessoryName = {
        id: data.id,
        accessory_name: data.accessory_name,
        created_by: data.created_by || null,
        sub_accessory: (data.sub_accessory && Array.isArray(data.sub_accessory)) ? mapFSAccessorySubNames(data.sub_accessory) : [],
    };

    return res;
};

export const mapFSAccessoryNames = (data: any[]): FSAccessoryName[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSAccessoryName);
};
